import { PreIPODealStatus } from '@constants/common';

export const shareLogTableHeader = [
  {
    id: 'sharePrice',
    label: 'Share Price',
    initialWidth: 120,
    disableSort: true
  },
  {
    id: 'shareMinValue',
    label: 'Lower Limit',
    initialWidth: 120,
    disableSort: true
  },
  {
    id: 'shareMaxValue',
    label: 'Upper Limit',
    initialWidth: 120,
    disableSort: true
  },
  {
    id: 'documentationChargesPercent',
    label: 'Documentation Charges (%)',
    initialWidth: 220,
    disableSort: true
  },
  {
    id: 'documentationChargesAmount',
    label: 'Documentation Charges (₹)',
    initialWidth: 220,
    disableSort: true
  },
  {
    id: 'platformChargesPercent',
    label: 'Platform Charges (%)',
    initialWidth: 180,
    disableSort: true
  },
  {
    id: 'platformChargesAmount',
    label: 'Platform Charges (₹)',
    initialWidth: 180,
    disableSort: true
  },
  {
    id: 'tax',
    label: 'Tax',
    initialWidth: 100,
    disableSort: true
  },
  {
    id: 'stampDuty',
    label: 'Stamp Duty',
    initialWidth: 120,
    disableSort: true
  },
  {
    id: 'dpCharges',
    label: 'Dp Charges',
    initialWidth: 120,
    disableSort: true
  }
];

export const isPreIPOBottomActionDisabled = (
  status: PreIPODealStatus
): boolean => {
  return (
    status === PreIPODealStatus.ACTIVE ||
    status === PreIPODealStatus.IN_REVIEW ||
    status === PreIPODealStatus.CLOSED
  );
};
